/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{font:400 16px/1.125 Roboto,\"Helvetica Neue\",sans-serif}.page-chat[_ngcontent-%COMP%]     .mat-drawer-content{margin-left:300px!important}@media screen and (max-width:959px){.page-chat[_ngcontent-%COMP%]     .mat-drawer-content{margin-left:0!important}}.page-chat[_ngcontent-%COMP%]     .mat-drawer{width:300px!important}"];
export { styles as styles };
